// extracted by mini-css-extract-plugin
export default {"card":"burger-constructor-card_card__Lb-X6","card_topping":"burger-constructor-card_card_topping__l+g72"};